<template>
	<div class="create-page">
		<div class="create-tab">基本信息</div>
		<!-- 索赔申请 -->
		<div class="create-section">
			<h3>
				索赔申请
				<div class="notice" v-if="form.repairType == 1" @click="dialogVisible = true">产品保修期限及例外条款</div>
			</h3>
			<div class="type-list">
				<el-tooltip
					class="item"
					effect="dark"
					content="请点击“保修期限及例外条款”确认申请零件是否属于保修范围并上移确认申请机型是否在保修期内"
					placement="bottom"
					popper-class="create-tooltip"
					v-if="form.id == undefined || (form.id && form.repairType == 1)">
					<div class="claim-type" @click="handleRepairType('1')" :class="form.repairType == 1 ? 'selected' : ''">
						保修期内机器零件故障
						<div class="tip">请点击“保修期限及例外条款”确认申请零件是否属于保修范围并上移确认申请机型是否在保修期内</div>
					</div>
				</el-tooltip>
				<el-tooltip
					class="item"
					effect="dark"
					content="仅限直接从理光订购零件的代理商申请"
					placement="bottom"
					popper-class="create-tooltip"
					v-show="contractLevelFlag"
					v-if="form.id == undefined || (form.id && form.repairType == 2)">
					<div class="claim-type" @click="handleRepairType('2')" :class="form.repairType == 2 ? 'selected' : ''">
						理光单独订购零件
						<div class="tip">仅限直接从理光订购零件的代理商申请</div>
					</div>
				</el-tooltip>
				<el-tooltip
					class="item"
					effect="dark"
					content="仅限直接从理光订购的代理商申请（参考：不同型号色粉储存及运输条件-最高温度分别低于40℃或50℃/湿度低于80%RH，35℃以下最大储存期1~2年）"
					placement="bottom"
					popper-class="create-tooltip"
					v-show="contractLevelFlag"
					v-if="form.id == undefined ||  (form.id && form.repairType == 3)">
					<div class="claim-type" @click="handleRepairType('3')" :class="form.repairType == 3 ? 'selected' : ''">
						商品（耗材）故障
						<div class="tip">
							仅限直接从理光订购的代理商申请（参考：不同型号色粉储存及运输条件-最高温度分别低于40℃或50℃/湿度低于80%RH，35℃以下最大储存期1~2年）
						</div>
					</div>
				</el-tooltip>
			</div>
		</div>
		<transition name="fade" mode="out-in">
			<component :is="currentComponent" :key="currentComponent"></component>
		</transition>
		<!-- 产品保修期限及例外条款弹框 -->
		<el-dialog title="" :visible.sync="dialogVisible" width="70%">
			<iframe title="产品保修期限及例外条款" src="https://ricohhome.i-unc.com/support/policy#exception" frameborder="0"></iframe>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="dialogVisible = false">已阅读</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
export default {
	components: {
		repairType1: () => import("./repairType1.vue"),
		repairType2: () => import("./repairType2.vue"),
		repairType3: () => import("./repairType3.vue"),
	},
	data() {
		return {
			// 产品保修期限及例外条款
			dialogVisible: false,
			currentComponent: "",
			form: {
				repairType: "", // 索赔的类型 1、保修期内机器零件故障 2、理光单独订购零件 3、商品（耗材故障）
			},
			contractLevelFlag: false,
		};
	},
	created() {
		const contractLevel = JSON.parse(window.sessionStorage.getItem('userInfo')).sysAgent.contractLevel;
		this.contractLevelFlag = contractLevel !== '1410436620354142210';
	},
	mounted() {
		// 获取单个索赔信息
		const claimId = sessionStorage.getItem("claimId") || this.$route.query.claimId;
		const repairType = sessionStorage.getItem("repairType") || this.$route.query.repairType;
		if (claimId) {
			this.form.id = "1";
			this.handleRepairType(String(repairType));
		} else {
			this.form.id ? delete this.form.id : "";
		}
	},
	methods: {
		// 索赔类型选择
		handleRepairType(repairType) {
			this.form.repairType = repairType;
			this.currentComponent = `repairType${repairType}`;
		},
	},
};
</script>

<style lang="scss" scoped>
.create-page {
	display: flex;
	flex-direction: column;
}
.create-tab {
	width: 160px;
	border-bottom: 2px solid #409eff;
	text-align: center;
	padding-bottom: 10px;
	margin-bottom: 20px;
}
.create-section {
	padding-bottom: 20px;
	border: 1px solid #ae8d5a;
	border-radius: 8px;
	h3 {
		height: 60px;
		line-height: 60px;
		padding: 0 20px;
		border-bottom: 1px solid #dcdfe6;
	}
}
.notice {
	color: #409eff;
	display: inline-block;
	text-decoration: underline;
	margin-left: 30px;
	cursor: pointer;
}
iframe {
	width: 100%;
	height: 70vh;
}
.create-page ::v-deep .el-dialog__header {
	display: none;
}
.create-page ::v-deep .el-dialog__body {
	padding: 0;
}
.type-list {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr; /* 定义列 */
	gap: 20px; /* 间距 */
	margin: 20px 20px 0;
	.claim-type {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		padding: 34px 20px;
		border-radius: 4px;
		border: 2px solid rgba(0, 0, 0, 0.15);
		font-size: 20px;
		font-weight: 500;
		color: #aaa7a7;
		cursor: pointer;
		.tip {
			margin-top: 10px;
			font-weight: 500;
			font-size: 12px;
			color: #666;
			word-break: break-all;
		}
	}
	.selected {
		border-color: #409eff;
		color: #409eff;
	}
}
/* 淡入淡出效果 */
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
	opacity: 0;
}

/* 滑动效果（可选） */
.slide-enter-active {
	transition: all 0.3s ease-out;
}
.slide-leave-active {
	transition: all 0.3s ease-in;
}
.slide-enter-from {
	opacity: 0;
	transform: translateX(30px);
}
.slide-leave-to {
	opacity: 0;
	transform: translateX(-30px);
}
</style>
